//Generated file - DO NOT MODIFY
import { observable, computed, action } from 'mobx';
import { serializable, identifier, update, deserialize } from 'serializr';
import _ from 'lodash';

export default class AgentBase {
    @serializable @observable agentId = '';
    @serializable @observable aspNetUserId = '';
    @serializable @observable agentContactId = '';
    @serializable @observable email = '';
    @serializable @observable preferredEmail = '';
    @serializable @observable firstName = '';
    @serializable @observable lastName = '';
    @serializable @observable name = '';
    @serializable @observable subscriberName = '';
    @serializable @observable subscriberId = '';

    static get __name__() {
        return 'Agent';
    }

    constructor(
        agentId = '',
        aspNetUserId = '',
        agentContactId = '',
        email = '',
        preferredEmail = '',
        firstName = '',
        lastName = '',
        name = '',
        subscriberName = '',
        subscriberId = ''
    ) {
        this.agentId = observable();
        this.agentId = agentId;
        this.aspNetUserId = observable();
        this.aspNetUserId = aspNetUserId;
        this.agentContactId = observable();
        this.agentContactId = agentContactId;
        this.email = observable();
        this.email = email;
        this.preferredEmail = observable();
        this.preferredEmail = preferredEmail;
        this.firstName = observable();
        this.firstName = firstName;
        this.lastName = observable();
        this.lastName = lastName;
        this.name = observable();
        this.name = name;
        this.subscriberName = observable();
        this.subscriberName = subscriberName;
        this.subscriberId = observable();
        this.subscriberId = subscriberId;
    }
}



// WEBPACK FOOTER //
// ./src/shared/agent-base.js